// ABOUTME: Empty placeholder shown when the entity loads successfully (200) but has no configuration to display.
import {TextSmallRegular} from '@hm/fundamental'
import React from 'react'

import {useTranslation} from '../../../../hooks/useTranslation'

export const EntityContentEmpty: React.FC = () => {
  const {t} = useTranslation()

  return (
    <div className="flex items-center justify-center h-full p-8">
      <TextSmallRegular className="text-foreground_faded">
        {t('countryConfigurations.entity.body.empty')}
      </TextSmallRegular>
    </div>
  )
}
